
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { RemoteSupport } from './components/RemoteSupport';
import { Services } from './components/Services';
import { RemoteHelp } from './components/RemoteHelp';
import { SiempreConectados } from './components/SiempreConectados';
import { About } from './components/About';
import { ITSupport } from './components/ITSupport';
import { Coverage } from './components/Coverage';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { FloatingCredentials } from './components/FloatingCredentials';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <RemoteHelp />
      <Services />
      <About />
      <ITSupport />
      <RemoteSupport />
      <SiempreConectados />
      <Coverage />
      <Contact />
      <Footer />
      <WhatsAppButton />
      <FloatingCredentials />
    </div>
  );
}
